<script>
  import { navigate } from "svelte-navigator";
  import GenericButton from "./GenericButton.svelte";
  export let className = "";
  export let route;
  export let name;
</script>

<GenericButton
  text={name}
  {className}
  onClick={() => navigate(route)}
  buttonIcon="plus"
  height="2.5rem"
  width="12rem"
/>
